export const itemsBaseApiPath = '/api/common/productMappings';

import {
  fetchItemsGen,
  deleteItemGen,
  getItemByIdGen
} from '../../../utils/apiHelperGenerators.js';

export const fetchItems = fetchItemsGen(itemsBaseApiPath, 'listItems');
export const deleteItem = deleteItemGen(itemsBaseApiPath);
export const getItemById = getItemByIdGen(itemsBaseApiPath);

export default {
  fetchItems,
  deleteItem,
  getItemById
};
